import JotionBanner from "../images/jotion.jpg";
import CarhubBanner from "../images/carhub.jpg";
import GerichtBanner from "../images/gericht.JPG";

export const Bio = {
  name: "Florian Fusari",
  roles: ["Développeur Fullstack", "Programmeur"],
  description:
    "En tant que développeur passionné, je suis toujours en quête d'apprentissage et de défis. Ma rigueur, ma recherche de l'excellence et ma capacité à collaborer en équipe font de moi un atout précieux pour chaque projet.",
  github: "https://github.com/FloCode7",
  resume:
    "https://drive.google.com/file/d/1tHXfM9zMTO_sBNeFcjIk6s6x9AzNZxzf/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/florian-fusari-4a3742200/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://diziglobalsolution.com/wp-content/uploads/2023/04/logo-css-3-1536.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Typescript",
        image:
          "https://a.storyblok.com/f/88751/512x512/3fd17e7d63/typescript_logo_2020.svg",
      },
      {
        name: "ReactJS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1200px-React-icon.svg.png",
      },
      {
        name: "NextJS",
        image: "https://www.svgrepo.com/show/354113/nextjs-icon.svg",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/768px-Tailwind_CSS_Logo.svg.png?20230715030042",
      },
      {
        name: "Material UI",
        image: "https://mui.com/static/logo.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "NodeJS",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "PHP",
        image: "https://pngimg.com/uploads/php/php_PNG50.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Postgresql_elephant.svg/1200px-Postgresql_elephant.svg.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Supabase",
        image:
          "https://d2eip9sf3oo6c2.cloudfront.net/tags/images/000/001/299/square_480/supabase-logo-icon_1.png",
      },
    ],
  },
  {
    title: "Annexe",
    skills: [
      {
        name: "Git",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/2048px-Git_icon.svg.png",
      },
      {
        name: "Github",
        image:
          "https://cdn.icon-icons.com/icons2/2429/PNG/512/github_logo_icon_147285.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Vercel",
        image:
          "https://assets.vercel.com/image/upload/front/favicon/vercel/180x180.png",
      },
      {
        name: "Wordpress",
        image:
          "https://images.icon-icons.com/836/PNG/512/Wordpress_icon-icons.com_66780.png",
      },
      {
        name: "Shopify",
        image:
          "https://cdn3.iconfinder.com/data/icons/social-media-2068/64/_shopping-512.png",
      },
    ],
  },
];

export const projects = [
  {
    id: 1,
    title: "Jotion",
    // date: "",
    description:
      "Application web fullstack de prise de notes, permet de créer des notes pour ses differents projets et/ou idées, de les classer et de les personnaliser avec des images.",
    image: `${JotionBanner}`,
    tags: [
      "ReactJS",
      "NextJS",
      "Typescript",
      "Tailwind CSS",
      "Clerk",
      "Convex",
      "Vercel",
    ],
    // category: "web app",
    github: "https://github.com/FloCode7/jotion",
    webapp: "https://notion-clone-snowy.vercel.app/",
  },
  {
    id: 2,
    title: "Gericht Restaurant",
    // date: "",
    description:
      "Landing page frontend moderne et responsive pour restaurant étoilé avec presentation des menus et des plats, et interfaces de reservation.",
    image: `${GerichtBanner}`,
    tags: ["Javascript", "ReactJS", "CSS", "MUI", "Netlify"],
    // category: "web app",
    github: "https://github.com/FloCode7/figma-restaurant",
    webapp: "https://unrivaled-lamington-8496e8.netlify.app/",
  },
  {
    id: 3,
    title: "CarHub",
    // date: "",
    description:
      "Application web frontend de location de voitures avec une grande variété de marques et tous types de modèles.",
    image: `${CarhubBanner}`,
    tags: [
      "ReactJS",
      "NextJS",
      "Typescript",
      "Tailwind CSS",
      "Rapid API",
      "Vercel",
    ],
    // category: "web app",
    github: "https://github.com/FloCode7/carhub",
    webapp: "https://rent-car-app-self.vercel.app/",
  },
];
